import { useContext, useState } from 'react';
import { CardHeader, CardContent, TextField, Grid, Button, CircularProgress, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { DatePicker } from '@material-ui/pickers';
import { Dropzone, FilterContainer } from 'components';
import { newRegistrationContext } from 'views/NewRegistration/NewRegistrationContext';
import { productContext } from './ProductContext';


let Customer = () => {
    let service = useContext(newRegistrationContext);
    let prodService = useContext(productContext);

    let [sku, setSku] = useState('');
    let [qrCode, setQrCode] = useState('');


    return (
        <>
            <CardHeader
                disableTypography
                title={<Typography variant="h4">Product information</Typography>}
            />
            <CardContent>
                <Grid container>
                    <Grid item xs={12}>
                        <DatePicker
                            label="Purchase Date"
                            variant="inline"
                            format="LL"
                            autoOk
                            inputVariant="outlined"
                            size="small"
                            value={service.registration.purchaseDate}
                            onChange={(date: any) => service.updateRegistration({
                                ...service.registration,
                                purchaseDate: date
                            })}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Serial Number"
                            variant="outlined"
                            value={service.registration.serialNumber}
                            onChange={(e: any) => service.updateRegistration({
                                ...service.registration,
                                serialNumber: e.target.value
                            })}
                        />
                    </Grid>
                </Grid>

                <Grid container>
                    <Grid item xs>
                        <Dropzone
                            isMultiple={false}
                            title="Upload receipt"
                            onDropCallback={async (files: any[]) => await prodService.uploadReceipt(files[0])}
                        />
                    </Grid>
                    {prodService.isUploading && <CircularProgress />}
                    {prodService.isUploading === false && prodService.isUploaded &&
                        <Grid item xs={12}>
                            <Typography>Receipt uploaded: <b>{service.registration.receiptFilename}</b></Typography>
                        </Grid>
                    }
                </Grid>

                <FilterContainer onSubmit={() => prodService.searchProduct(sku)}>
                    <Grid item xs>
                        <TextField
                            label="SKU / EAN / UPC"
                            variant="outlined"
                            value={sku}
                            onChange={(e: any) => setSku(e.target.value)}
                        />
                    </Grid>
                    <Grid item>
                        <Button
                            type="submit"
                            color="secondary"
                            variant="contained"
                            disabled={prodService.isSearching}
                        >
                            {prodService.isSearching && <CircularProgress size={20} />}&nbsp;Find product
                        </Button>
                    </Grid>
                </FilterContainer>

                {prodService.isSearching === false && prodService.isSearchDone &&
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography gutterBottom>
                                {service.registration.productBrand}&nbsp;&middot;&nbsp;
                                {service.registration.sku}&nbsp;&middot;&nbsp;
                                {service.registration.shortDescription}
                            </Typography>
                        </Grid>
                    </Grid>
                }

                {service.registration.isQrCodeMandatory &&
                    <>
                        <Grid container>
                            <Grid item xs>
                                {prodService.isValidationDone === false &&
                                    <Alert severity="warning" variant="outlined">Please write a QR code (it is mandatory for the product)</Alert>
                                }
                                {prodService.isValidationDone === true &&
                                    <>
                                        {prodService.isQrCodeValid &&
                                            <Alert severity="success" variant="outlined">QrCode is valid</Alert>
                                        }
                                        {prodService.isQrCodeValid === false &&
                                            <Alert severity="error" variant="outlined">QrCode is not valid</Alert>
                                        }
                                    </>
                                }
                            </Grid>
                        </Grid>

                        <FilterContainer onSubmit={() => prodService.validateQrCode(qrCode)}>
                            <Grid item xs>
                                <TextField
                                    label="QrCode (mandatory)"
                                    variant="outlined"
                                    value={qrCode}
                                    onChange={(e: any) => setQrCode(e.target.value)}
                                />
                            </Grid>
                            <Grid item>
                                <Button
                                    type="submit"
                                    color="secondary"
                                    variant="contained"
                                    disabled={prodService.isValidating}
                                >
                                    {prodService.isValidating && <CircularProgress size={20} />}&nbsp;Validate QrCode
                                </Button>
                            </Grid>
                        </FilterContainer>
                    </>
                }
            </CardContent>
        </>
    )
}

export default Customer;